import { api } from './api';

/**
 * Retrieve the latest measurements for a given patient.
 * @param {string} patientUUID - The UUID of the patient.
 * @returns {Promise<object>} - A dictionary keyed by measurement type, each containing up to 3 latest records.
 */
export const getLatestMeasurements = async (patientUUID) => {
    const response = await api.post('/cheart/measurements/latest', {
        patient: patientUUID
    });
    return response.data;
};

/**
 * Retrieve measurements of a given type for a patient between two dates.
 * @param {string} patientUUID - The UUID of the patient.
 * @param {string} type - The measurement type (e.g., HEART_RATE, BLOOD_PRESSURE).
 * @param {string} qi - Start date (YYYY-MM-DD).
 * @param {string} qf - End date (YYYY-MM-DD).
 * @returns {Promise<object>} - A dictionary of formatted measurement records.
 */
export const getMeasurements = async (patientUUID, type, qi, qf) => {
    const response = await api.post('/cheart/measurements', {
        patient: patientUUID,
        type,
        qi,
        qf
    });
    return response.data;
};
